import AssignedProjectsCollection from '../collections/AssignedProjectsCollection';
import CloseoutsSummaryCollection from '../collections/CloseoutsSummaryCollection';
import CompaniesCollection from '../collections/CompaniesCollection';
import DirectoriesCollection from '../collections/DirectoriesCollection';
import EventHistoriesCollection from '../collections/EventHistoriesCollection';
import FavoritesCollection from '../collections/FavoritesCollection';
import InventoryItemsCollection from '../collections/InventoryItemsCollection';
import LocationProjectsNavCollection from '../collections/LocationProjectsNavCollection';
import LocationsCollection from '../collections/LocationsCollection';
import LocationsNavCollection from '../collections/LocationsNavCollection';
import LocationProjectsCollection from '../collections/LocationProjectsCollection';
import MarketsCollection from '../collections/MarketsCollection';
import MarketUsersCollection from '../collections/MarketUsersCollection';
import ProjectActivityCollection from '../collections/ProjectActivityCollection';
import ProjectAnalysisCollection from '../collections/ProjectAnalysisCollection';
import ProjectLocationsCollection from '../collections/ProjectLocationsCollection';
import ProjectReportCollection from '../collections/ProjectReportCollection';
import ProjectsCollection  from '../collections/ProjectsCollection';
import ProjectTypesCollection from '../collections/ProjectTypesCollection';
import TasksAssignedByProjectCollection from '../collections/TasksAssignedByProjectCollection';
import TasksAssignedCollection from '../collections/TasksAssignedCollection';
import TeamsCollection from '../collections/TeamsCollection';
import UserProjectsCollection from '../collections/UserProjectsCollection';
import UsersCollection from '../collections/UsersCollection';
import VendorUsersCollection from '../collections/VendorUsersCollection';
import UnreadAnnouncementsCollection from '../collections/UnreadAnnouncementsCollection';

export default class CollectionFactory {
  constructor(type, name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10) {
    switch (type) {
    case 'AssignedProjectsCollection':
      return AssignedProjectsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'CloseoutsSummaryCollection':
      return CloseoutsSummaryCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'CompaniesCollection':
      return CompaniesCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'DirectoriesCollection':
      return DirectoriesCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'EventHistoriesCollection':
      return EventHistoriesCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'FavoritesCollection':
      return FavoritesCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'InventoryItemsCollection':
      return InventoryItemsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'LocationProjectsNavCollection':
      return LocationProjectsNavCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'LocationsCollection':
      return LocationsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'LocationsNavCollection':
      return LocationsNavCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'LocationProjectsCollection':
      return LocationProjectsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'MarketsCollection':
      return MarketsCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'MarketUsersCollection':
      return MarketUsersCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'ProjectActivityCollection':
      return ProjectActivityCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'ProjectAnalysisCollection':
      return ProjectAnalysisCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'ProjectLocationsCollection':
      return ProjectLocationsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'ProjectReportCollection':
      return ProjectReportCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'ProjectsCollection':
      return ProjectsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'ProjectTypesCollection':
      return ProjectTypesCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'TasksAssignedByProjectCollection':
      return TasksAssignedByProjectCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'TasksAssignedCollection':
      return TasksAssignedCollection.build(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'TeamsCollection':
      return TeamsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'UserProjectsCollection':
      return UserProjectsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'UsersCollection':
      return UsersCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'VendorUsersCollection':
      return VendorUsersCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    case 'UnreadAnnouncementsCollection':
      return UnreadAnnouncementsCollection.build(name, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10);
    default:
      break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/DataSource/CollectionFactory.js